var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61893 0.0929297L9.67014 0.11918L11.317 1.07004C11.9224 1.41949 12.144 2.1784 11.834 2.79504L11.7973 2.86301L10.8465 4.50984C10.6912 4.77891 10.3471 4.87102 10.0781 4.71574C9.82588 4.57008 9.72908 4.25871 9.84592 3.99855L9.87217 3.94734L10.599 2.68852C8.58416 3.03258 7.24893 4.18477 6.52928 6.19008C6.4244 6.48246 6.10225 6.63445 5.80987 6.52945C5.51748 6.42457 5.36549 6.10242 5.47037 5.81004C6.28729 3.53367 7.83756 2.1327 10.0656 1.64672L9.10752 1.09348C8.83846 0.938203 8.74635 0.594141 8.90162 0.325078C9.0474 0.0727734 9.35889 -0.0239063 9.61893 0.0929297ZM6.00006 0C6.31073 0 6.56256 0.251836 6.56256 0.5625C6.56256 0.873164 6.31073 1.125 6.00006 1.125C3.30768 1.125 1.12506 3.30762 1.12506 6C1.12506 8.69238 3.30768 10.875 6.00006 10.875C8.69244 10.875 10.8751 8.69238 10.8751 6C10.8751 5.68934 11.1269 5.4375 11.4376 5.4375C11.7482 5.4375 12.0001 5.68934 12.0001 6C12.0001 9.31371 9.31377 12 6.00006 12C2.68635 12 6.10352e-05 9.31371 6.10352e-05 6C6.10352e-05 2.68629 2.68635 0 6.00006 0Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.f34d026db5050264765378deb6e9edce.svg";
export { ForwardRef as ReactComponent };